import Http from './http'

let Patient = {
  /**
   * Retorna uma lista com os exames do usuário autenticado
   * @return Array
   */
  getExams: () => Http.get('/exams/getAll'),
  getExam: (examId) => Http.get(`/exams/${examId}`),
  getCep: (cep) => Http.get("/clinic/cep/" +cep),
  getData: () => Http.get("/patient/getData"),
  checkIn: (data) => Http.post("/patient/checkin",data),
  
}

export default Patient;


// WEBPACK FOOTER //
// ./src/services/patient.js